import { Link } from "react-router-dom";
import type { CharacterItem } from "@/types/content";

export default function CharacterCard({ item }: { item: CharacterItem }) {
  return (
    <Link
      to={`/detail/character/${item.id}`}
      className="group block rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[4/5] overflow-hidden">
        <img
          src={item.image}
          alt={item.name}
          title={`${item.name} - 香蕉动漫`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 rounded-full bg-accent-500/95 px-2 py-0.5 text-[10px] font-bold text-white">
          {item.gender}
        </span>
      </div>
      <div className="p-3">
        <h3 className="font-bold text-sm text-foreground-950 line-clamp-1 group-hover:text-accent-600 transition-colors">
          {item.name}
        </h3>
        <p className="mt-0.5 text-xs text-foreground-500">《{item.work}》</p>
        <p className="mt-1.5 text-xs text-foreground-600 line-clamp-2">{item.intro}</p>
      </div>
    </Link>
  );
}